import _ from 'lodash';
import { getCookie } from 'helpers/Storage';
import { VCHIP_RATINGS } from 'helpers/auth.clientless';

export const resetState = {
  iFrameHeight: 400,
  isAuthenticated: null,
  mvpdBuythroughData: null,
  playbackErrorText: null,
  preauthorizedResources: null,
  previewPassSignIn: false,
  renderContentBlackout: null,
  renderFailure: null,
  renderLoading: null,
  renderMvpdDirectSignInRedirect: null,
  renderMVPDExpireSignIn: null,
  renderMVPDIncomplete: null,
  renderMVPDRetry: null,
  renderMVPDSearch: null,
  renderMVPDStart: null,
  renderNotEntitled: null,
  renderPlaybackError: null,
  renderPreviewPassWelcome: null,
  renderProfilePcsError: false,
  renderResumeWithoutProfile: null,
  renderResumeWithProfile: null,
  renderSignIn: null,
  renderSuccess: null,
  renderUpsellError: null,
  signInTrigger: null,
  successResources: null,
  successTimeout: null,
};

export const defaultState = {
  ...resetState,
  renderExpiredPreviewPass: null,
  resumeWithProfileRendered: false,
  renderNoSportsOnMobileError: null,
  baseChannel: null,
  renderUnlockUpsell: false,
};

export const OVERLAY_AUTH_MVPD_DIRECT_SIGN_IN_REDIRECT =
  'OVERLAY_AUTH_MVPD_DIRECT_SIGN_IN_REDIRECT';
export const OVERLAY_AUTH_MVPD_START = 'OVERLAY_AUTH_MVPD_START';
export const OVERLAY_AUTH_MVPD_SEARCH = 'OVERLAY_AUTH_MVPD_SEARCH';
export const OVERLAY_AUTH_SUCCESS = 'OVERLAY_AUTH_MVPD_SUCCESS';
export const OVERLAY_AUTH_LOADING = 'OVERLAY_AUTH_MVPD_LOADING';
export const OVERLAY_AUTH_FAILURE = 'OVERLAY_AUTH_FAILURE';
export const OVERLAY_AUTH_UPSELL_ERROR = 'OVERLAY_AUTH_UPSELL_ERROR';
export const OVERLAY_AUTH_UPSELL_CONFIRM = 'OVERLAY_AUTH_UPSELL_CONFIRM';

export function isRatingAuthorized(contentRating, userRating) {
  if (!userRating || !contentRating) return true;
  const contentIndex = VCHIP_RATINGS.indexOf(contentRating.toLowerCase());
  const userIndex =
    userRating && _.isString(userRating) ? VCHIP_RATINGS.indexOf(userRating.toLowerCase()) : null;
  const invalidContentRating = contentIndex === -1;
  const invalidUserIndex = userIndex === -1 || userIndex === null;
  const invalidComparison = invalidUserIndex || invalidContentRating;
  if (invalidComparison) return true;
  return contentIndex <= userIndex;
}

export function isContentAuthorized(authorizedNetworkNames, contentNetworkNames, networks) {
  if (!authorizedNetworkNames || !authorizedNetworkNames.length) return false;

  const updatedContentNetworkNames = contentNetworkNames.map(networkName => {
    const networkNameOverride = _.get(networks, networkName);
    if (networkNameOverride) return networkNameOverride.resourceId;
    return networkName;
  });
  const isAuthorized = !!_.intersection(authorizedNetworkNames, updatedContentNetworkNames).length;

  return isAuthorized;
}

export function mvpdUser(mvpdCookieName) {
  return !!getCookie({ name: mvpdCookieName });
}

export function getAuthorizedResources(authorizedNetworks, additionalNetworks) {
  if (!authorizedNetworks) return [];
  if (!additionalNetworks || _.isEmpty(additionalNetworks) || authorizedNetworks.length === 0) {
    return authorizedNetworks;
  }
  const newAuthorizedNetworks = [];
  authorizedNetworks.forEach(network => {
    if (_.has(additionalNetworks, network)) {
      additionalNetworks[network].forEach(netw => {
        newAuthorizedNetworks.push(netw);
      });
    }
  });
  return _.union(newAuthorizedNetworks, authorizedNetworks);
}
